module.exports = __webpack_public_path__ + "img/cercaselectricas.388ac937.jpg";